<template>
  <div id="ramdom-word">
    <p>{{ currentWord }}</p>
  </div>
</template>

<script>
import utils from '../services/tools';

const when = [
  '慵懒的周末',
  '凌晨两点',
  '凌晨四点',
  '下午一点',
  '下雪的傍晚',
  '下暴雨的夜晚',
  '晴天的时候',
  '停电的夜晚',
  '生日那天',
  '万圣节那天',
  '旅行的第一天',
];

const where = [
  '在只有我一个乘客的飞机上',
  '在东京的街头',
  '在拉斯维加斯的赌场里',
  '在首尔弘大街头',
  '在莫斯科的郊区',
  '在南极企鹅堆里',
  '在北极熊的怀里',
  '在加拿大的小树林里',
  '在机场厕所马桶边',
  '在摆渡车里',
  '在成田机场',
  '在香港迪士尼乐园过山车上',
  '在河内的长途巴士上',
  '在泰国的马杀鸡店里',
  '在斯里兰卡的沿海火车上',
  '在印度恒河里',
  '在民宿浴室的镜子前',
  '在中国城的火锅店里 ',
  '在电影院里',
  '在楼下的便利店',
  '在地铁口',
  '在公园长椅上',
];

const what = [
  '帮对方掏耳朵',
  '看泰国鬼片',
  '骂对方不是人',
  '把对方举高高',
  '不说话，静静地看对方一分钟',
  '做仰卧起坐',
  '帮对方擦嘴',
  '和对方自拍一张',
  '问对方：你有freestyle吗？',
  '疯狂斗舞',
  '装作陌生人，重新认识对方',
  '给对方一巴掌',
  '和对方掰手腕',
  '唱江南皮革厂倒闭了',
  '咬对方耳朵',
];

export default {
  name: 'ramdom-word',
  data() {
    return {
      when,
      where,
      what,
      currentWord: '',
    };
  },
  methods: {
    getParamByName(name) {
      utils.noop(this);
      return location.href.split(`${name}=`)[1].split('&')[0];
    },
    setCurrentWord(type) {
      if (type && this[type]) {
        const index = Math.floor(Math.random() * this[type].length);
        this.currentWord = this[type][index];
      }
    },
  },
  created() {
    const title = this.getParamByName('type');
    document.title = title;
    this.setCurrentWord(title);
  },
};
</script>

<style lang="less" scoped>
#ramdom-word {
  box-sizing: border-box;
  height: 100%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  p {
    color: #333;
    font-size: 22px;
  }
}
</style>
